import React from "react";
import "./ConstruccionCivil.css"; 
import desarrolloImg from "../assets/images/sistemas.jpg";
import pdfMalla from "../assets/docs/desarrollo.pdf";
import { FaDownload, FaLaptopCode } from "react-icons/fa";

const DesarrolloSistemas = () => {
  return (
    <section className="carrera-detalle">
      {/*  Banner s */}
      <div className="carrera-hero-modern" style={{ backgroundImage: `url(${desarrolloImg})` }}>
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold">Desarrollo de Sistemas de Información</h1>
          <p>Formamos profesionales técnicos en programación, innovación y gestión de tecnologías.</p>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="container my-5">
        <div className="row g-4">
        
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3">
                <FaLaptopCode className="me-2" />
                TÍTULO: PROFESIONAL TÉCNICO EN DESARROLLO DE SISTEMAS DE INFORMACIÓN
              </h3>

              <h5 className="fw-bold text-primary mt-4">DESCRIPCIÓN DEL PERFIL DE EGRESO</h5>
              <p>
                El profesional técnico en Desarrollo de Sistemas de Información del Instituto de Educación Superior Tecnológico Público
                “Gilda Liliana Ballivián Rosado”, tiene competencias para desarrollar software y sistemas informáticos multiplataforma;
                realizar pruebas integrales de servicios de TI; implementar y administrar el diseño funcional de los sistemas informáticos.
              </p>
              <p>
                Asimismo, se comunica de manera efectiva, empleando el idioma oficial e inglés, y utiliza tecnologías de información como
                herramientas en la solución de problemas, fomentando la innovación, la ética profesional y el liderazgo colaborativo,
                tanto en instituciones públicas como privadas.
              </p>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIA GENERAL</h5>
              <p>
                Planificar, implementar y gestionar el uso de las tecnologías de información y comunicación en una organización,
                analizando sus requerimientos y garantizando la calidad, seguridad y ética profesional, promoviendo el trabajo en equipo.
              </p>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIAS ESPECÍFICAS</h5>
              <ul>
                <li>
                  Desarrollar programas de sistemas de información según el diseño funcional, estándares internacionales de TI
                  y buenas prácticas de programación.
                </li>
                <li>
                  Ejecutar pruebas integrales de los sistemas y servicios de TI durante la implantación, garantizando seguridad
                  y eficiencia.
                </li>
                <li>
                  Administrar el diseño funcional de los sistemas informáticos de acuerdo con las demandas del negocio y
                  la arquitectura vigente.
                </li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">CAMPOS DE ACCIÓN</h5>
              <p>
                El profesional técnico en Desarrollo de Sistemas de Información puede desempeñarse en el sector público y privado,
                tanto a nivel nacional como internacional, o crear su propia empresa tecnológica.
              </p>
              <ul>
                <li>Gerente de micro y pequeña empresa</li>
                <li>Jefe o asistente de soporte técnico</li>
                <li>Administrador de base de datos</li>
                <li>Diseñador gráfico, web y multimedia</li>
                <li>Desarrollador de software y sistemas empresariales</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">SALIDA HACIA OTROS ESTUDIOS</h5>
              <ul>
                <li>Ingeniería de Sistemas</li>
                <li>Ingeniería en Computación e Informática</li>
                <li>Ingeniería Informática</li>
                <li>Ingeniería de Software</li>
                <li>Comercio Electrónico</li>
              </ul>
            </div>
          </div>

          {/*  Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img src={desarrolloImg} alt="Desarrollo de Sistemas" className="img-fluid rounded-3 mb-3" />
              <a href={pdfMalla} target="_blank" rel="noopener noreferrer" className="btn btn-download w-100">
                <FaDownload className="me-2" /> Descargar Malla Curricular 2024 (PDF)
              </a>
              <div className="mt-4 text-start">
                <h6 className="text-primary fw-bold">DURACIÓN</h6>
                <p className="mb-2">6 semestres equivalentes a 3 años académicos.</p>
                <h6 className="text-primary fw-bold">TURNOS DE ESTUDIO</h6>
                <p className="mb-0">Diurno: 8:00 a.m. a 1:00 p.m.</p>
                <p className="mb-0">Nocturno: 6:00 p.m. a 10:20 p.m.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesarrolloSistemas;
